import type { ExplorationVolume } from '../../types/exploration';
import { buildSupportFilterGroups } from '../../lib/filters/buildCheckboxFilterOptions';
import FilterCheckboxDisclosure from './FilterCheckboxDisclosure';
import SupportFilterList from './SupportFilterList';

export default function SupportStatusFilter({
  volumes,
  open,
  onOpenChange,
  pendingSupportStatuses,
  setPendingSupportStatuses,
}: {
  volumes: ExplorationVolume[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pendingSupportStatuses: string[];
  setPendingSupportStatuses: (statuses: string[]) => void;
}) {
  const groups = buildSupportFilterGroups(volumes);

  const handleChange = (optionId: string) => {
    if (pendingSupportStatuses.includes(optionId)) {
      setPendingSupportStatuses(pendingSupportStatuses.filter((s) => s !== optionId));
    } else {
      setPendingSupportStatuses([...pendingSupportStatuses, optionId]);
    }
  };

  if (!groups.length) return null;

  return (
    <FilterCheckboxDisclosure
      title="Eligibility"
      open={open}
      onOpenChange={onOpenChange}
      selectedCount={pendingSupportStatuses.length}
      onClear={() => setPendingSupportStatuses([])}
    >
      <SupportFilterList
        groups={groups}
        pendingSupportStatuses={pendingSupportStatuses}
        onToggleStatus={handleChange}
        onSetPendingSupportStatuses={setPendingSupportStatuses}
        isDisclosureOpen={open}
      />
    </FilterCheckboxDisclosure>
  );
}
